import React from 'react'
import gql from 'graphql-tag'

import Query from 'components/shared/Query'
import Heading from 'components/shared/Heading'

import ExecutiveOfficersList from './ExecutiveOfficersList'

const EXECUTIVE_OFFICERS_QUERY = gql`
  query PhotoOrderPreference {
    viewer {
      id
      broker {
        id
        executiveOfficers(first: 20) {
          edges {
            node {
              id
              email
            }
          }
        }
      }
    }
  }
`

const ExecutiveOfficers = () => {
  return (
    <>
      <Heading level={2}>Saksbehandlere</Heading>
      <Query
        inlineError
        inlineLoading
        query={EXECUTIVE_OFFICERS_QUERY}
      >
        {({getData}) => {
          const executiveOfficers = getData('viewer.broker.executiveOfficers.edges').map(e => e.node)
          return (
            <ExecutiveOfficersList
              executiveOfficers={executiveOfficers}
            />
          )
        }}
      </Query>
    </>
  )
}

export default ExecutiveOfficers
